<app-searchbox-wrapper></app-searchbox-wrapper>
<div class="home-container">
  <app-tab-selector [selectedTab]="'plan-instruction'"></app-tab-selector>
  <div class="ss-container renaissance-style-scoped" aria-labelledby="skip-nav">
    <div class="ss-header-container">
      <div class="ss-header">
        <h2 id="skip-nav">Plan Instruction</h2>
        <p class="description">State standards and aligned skills, with practice and instructional resources.</p>
      </div>
    </div>
  </div>
  <span *ngIf="!(isLoading$ | async)">
    <div class="context-selector">
      <scope-sequence-filters [scopeAndSequenceStandards]="scopeAndSequenceStandards"
        (updateSkillOrder)="updateSkillOrderSelection($event)" (updateGrade)="updateGradeSelection($event)"
        (updateSubject)="updateSubjectSelection($event)"></scope-sequence-filters>
    </div>

    <div *ngIf="!showTryAgainButton && !(isLoadingStandardResults$ | async)">
      <span *ngIf="isEnvision" class="skill-order-container">
        <img class="scope-sequence-savvas-logo" [src]="'assets/logos/savvas_logo.svg'" />
        <div class="skill-text-container">
          <div class="skill-text">{{ selectedSkillOrder }}</div>
          <div class="skill-grade">
            Grade {{ selectedGrade }}
          </div>
        </div>
      </span>
      <app-standard-results [skillOrder]="selectedSkillOrder"
        [domainStandardSets]="domainStandards"></app-standard-results>
    </div>
    <div *ngIf="isLoadingStandardResults$ | async">
      <mat-spinner diameter="60" mode="indeterminate" class="mat-spinner skills-spinner"></mat-spinner>
    </div>

    <app-degraded *ngIf="showTryAgainButton" [enableVerticalCentering]="false"
      [tryAgainRoute]="'/plan-instruction'"></app-degraded>
  </span>
  <div *ngIf="isLoading$ | async">
    <mat-spinner diameter="60" mode="indeterminate" class="mat-spinner skills-spinner"></mat-spinner>
  </div>
</div>
<app-footer></app-footer>
